import axios from "axios";
import { LANG } from "@/lib/i18n/lang";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BASE}/api`;

const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

// Attach optional bearer for cases where cookie isn't set (e.g. iframe preview).
api.interceptors.request.use((config) => {
  config.headers = config.headers || {};
  config.headers["X-Site-Lang"] = LANG;
  const t = typeof window !== "undefined" ? window.localStorage.getItem("gcw_bearer") : null;
  if (t) {
    config.headers = config.headers || {};
    if (!config.headers.Authorization) {
      config.headers.Authorization = `Bearer ${t}`;
    }
  }
  return config;
});

export default api;
